import React, { useEffect, useState } from 'react'
import { Typography } from '@mui/material'
import PendingTransaction from './PendingTransaction'
import { addToastMsg } from '../services/amm'
import { useWalletContext } from './WalletContext'
import Spinner from './Spinner'
import PrimaryButton from './PrimaryButton'
import Popup from './Popup'
import { useStoreState } from '../model/hooks'
import { Transaction } from '../atoms.js'

function PendingTransactions() {
    const { networkName: network } = useWalletContext()

    // const [lastTx, setLastTx] = useState('')
    const [open, setOpen] = useState(false)
    const transactions = useStoreState((state) => state.transaction.transactions)
    const [txs, setTxs] = useState([] as Transaction[])
    const [txsToasted, setTxsToasted] = useState([] as string[])
    const handleClose = () => {
        setOpen(false)
    }

    useEffect(() => {
        getRelevenantTxs()
    }, [transactions])

    function getRelevenantTxs() {
        const transactionList: Transaction[] = []
        const values = Object.values(transactions)
        values.map((tx) => {
            transactionList.push(tx)
        })
        setTxs(transactionList)
    }

    useEffect(() => {
        if (txs && txs.length > 0) updateTransactionsStatus()
    }, [txs])

    const checkAndUpdate = async (tx: Transaction) => {
        setTxsToasted([...txsToasted, tx.hash])
        // if (tx.pool_id && tx.pool_id > 0 && lastTx !== tx.hash) {
        //     setLastTx(tx.hash)
        // }
    }

    const updateTransactionsStatus = async () => {
        txs.forEach(async (tx) => {
            if (!tx.dismiss) {
                let tx_status = tx.status
                let name = tx.type
                    .split(/ |_/)
                    .map((x) => x[0].toUpperCase() + x.slice(1))
                    .join(' ')
                if (tx_status !== undefined) {
                    if (tx_status.includes('RECEIVED')) {
                        //addToastMsg(name + ' Transaction Sent', 'success')
                    }
                    if (tx_status.includes('REJECTED')) {
                        if (tx.error) {
                            addToastMsg(name + ' Transaction Rejected: ' + tx.error, 'error')
                        } else {
                            addToastMsg(name + ' Transaction Rejected', 'error')
                        }
                    }
                    if (tx_status.includes('REVERTED') && !txsToasted.includes(tx.hash)) {
                        if (tx.error) {
                            addToastMsg(name + ' Transaction Reverted: ' + tx.error, 'error')
                            checkAndUpdate(tx)
                        } else {
                            addToastMsg(name + ' Transaction Reverted', 'error')
                            checkAndUpdate(tx)
                        }
                    }
                    if (tx_status.includes('PENDING') && !txsToasted.includes(tx.hash)) {
                        addToastMsg(name + ' Transaction Done', 'success')
                        checkAndUpdate(tx)
                    }
                    if (tx_status.includes('ACCEPTED') && !txsToasted.includes(tx.hash)) {
                        addToastMsg(name + ' Transaction Accepted', 'success')
                        checkAndUpdate(tx)
                        // updateTx({ hash: tx.hash, ...{ ...tx, dismiss: true } })
                    }
                }
            }
        })
    }

    const pendingTransactions = () => {
        if (txs.length === 0) {
            return (
                <Typography fontSize={18} sx={{ m: 4 }}>
                    Session transactions will appear here
                </Typography>
            )
        }

        let r: JSX.Element[] = []
        txs.forEach((tx) => {
            r.push(<PendingTransaction key={tx.hash} network={network!} tx={tx as any} />)
        })
        return r
    }

    const transactionHistoryModal = () => {
        return (
            <Popup title='Transaction history' onClose={handleClose} open={open}>
                <>
                    <div>{pendingTransactions()}</div>
                    <PrimaryButton size='sm' className='mt-[40px] rounded-[16px] py-1 px-1 lg:py-1 lg:px-1' onClick={() => setOpen(false)}>
                        <span className='text-[16px]'>Close</span>
                    </PrimaryButton>
                </>
            </Popup>
        )
    }

    const txHistoryButton = () => {
        if (txs.length === 0) return

        let txInProgress = txs.find((e) => ['new', 'RECEIVED'].includes(e.status))
        let text = txInProgress && txInProgress.status === 'RECEIVED' ? 'Received' : 'New'
        return (
            <PrimaryButton size='sm' className='cursor-pointer mr-2 lg:mr-8' onClick={() => setOpen(true)}>
                <>
                    {txInProgress ? <Spinner /> : null}

                    <span className='text-[12px] lg:text-[14px]'>{txInProgress !== undefined ? text : 'TX History'}</span>
                </>
            </PrimaryButton>
        )
    }

    if (txs.length !== 0)
        return (
            <div>
                {txHistoryButton()}
                {transactionHistoryModal()}
            </div>
        )
    return <div></div>
}

export default PendingTransactions
